import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseConfig } from '@client';

@Component({
  selector: 'app-side-menu-item-child',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './side-menu-item-child.component.html',
  styleUrls: ['./side-menu-item-child.component.scss'],
})
export class SideMenuItemChild extends BaseConfig {
  active = input<boolean>(false);
}
